<div class="row mt-3">
  <div class="btn-toolbar justify-content-center" role="toolbar">
    <div class="btn-group me-2" role="group" aria-label="Change Time Period">
      <button [disabled]="projectedStarted === 'Yet To Start'" class="btn-secondary btn" [class.active]="currentSelection === 'projected'"
              (click)="setChartData('projected');">Projected Price
      </button>
      <button [disabled]="harvestStarted === 'Yet To Start'" class="btn-secondary btn" [class.active]="currentSelection === 'harvest'"
              (click)="setChartData('harvest');">Harvest Price
      </button>
      <button class="btn-secondary btn" [class.active]="currentSelection === 'history'"
              (click)="setChartData('history');">Price History
      </button>
    </div>
  </div>
  <div class="col-md-4 col-sm-12">
  </div>
</div>

<div class="row">
  <div id="{{id}}-{{harvestCode}}-{{actuarialDate}}-{{practiceCode}}-{{currentSelection}}" class="col-md-8 col-sm-12 col-xs-12 align-content-center"
       style="height: 600px; margin-bottom: 10px;">
    <div *ngIf="chartData.length === 0" style="margin-left: auto;margin-right: auto; width: 100%; height: 600px;">{{chartMessage}}</div>
  </div>

  <div class="col-md-4 col-sm-12 col-xs-12">
    <div class="table-responsive pricing-table" [class.active]="currentSelection==='history'">
      <table class="table table-striped" *ngIf="currentSelection === 'history'">
        <thead>
        <tr>
          <th scope="col">Year</th>
          <th scope="col">Projected</th>
          <th scope="col">Volatility</th>
          <th scope="col">Harvest</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let price of historyTable?.tableData | orderBy: '-date'">
          <td scope="row">{{price.date}}</td>
          <td>{{price.openingPrice * 100 | currency: 'USD' : 'symbol'}}</td>
          <td>{{price.volatility}}</td>
          <td>{{price.endingPrice * 100 | currency: 'USD':'symbol'}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive pricing-table" [class.active]="currentSelection==='harvest'">
      <table class="table table-striped" *ngIf="currentSelection === 'harvest'">
        <thead>
        <tr>
          <th>Date</th>
          <th>Open</th>
          <th>Close</th>
          <th>Factor</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let price of historyTable.dataPoints">
          <td scope="row">{{price.date}}</td>
          <td>${{price.openingPrice | number: '1.4'}}</td>
          <td>${{price.endingPrice | number: '1.4'}}</td>
          <td>{{price.multiplicativeFactor | number: '1.4'}}</td>
          <td>{{price.rmaPrice | currency: 'USD':'symbol'}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive pricing-table" [class.active]="currentSelection==='projected'">
      <table class="table table-striped" *ngIf="currentSelection === 'projected'">
        <thead>
        <tr>
          <th>Date</th>
          <th>Open</th>
          <th>Close</th>
          <th>Factor</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let price of historyTable.dataPoints">
          <td scope="row">{{price.date}}</td>
          <td>${{price.openingPrice | number: '1.4'}}</td>
          <td>${{price.endingPrice | number: '1.4'}}</td>
          <td>{{price.multiplicativeFactor | number: '1.4'}}</td>
          <td>{{price.rmaPrice | currency: 'USD':'symbol'}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
